/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './controls.styles.css';
import useEventListener from '../../hooks/useEventListener';

export default function ControlsVolumeSlider({ config, videoPlayer }) {
  function handleProgress() {
    const progress = document.getElementById(config.targetId).querySelector('.progress-bar');
    const rect = progress.getBoundingClientRect();
    const cursor = document.getElementById(config.targetId).querySelector('#myCursorLevelVolume');
    const realWidth = rect.width * config.volume;
    cursor.style.left = `${realWidth - 6}px`;
  }

  function handleProgressClick(event) {
    const progress = document.getElementById(config.targetId).querySelector('.progress-bar');
    const rect = progress.getBoundingClientRect();
    const x = event.pageX - rect.left; // or e.offsetX (less support, though)
    const cursor = document.getElementById(config.targetId).querySelector('#myCursorLevelVolume');
    cursor.style.left = `${x - 6}px`;
    const percentVolume = parseInt((100 * x) / rect.width, 10);
    videoPlayer.setVolume(percentVolume / 100);
  }

  useEffect(() => {
    handleProgress();
  });

  useEventListener('resize', handleProgress);

  return (
    <div className={'slider-progress'}>
      <div className={'progress-bar'} onClick={handleProgressClick}></div>
      <span id={'myCursorLevelVolume'} className={'pointer indicator'}></span>
    </div>
  );
}

ControlsVolumeSlider.propTypes = {
  config: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
};
